import { Cryptor } from "./aes-cryptor"

export class EncryptedStorage {
    constructor(
        private readonly storage: Storage,
        private readonly cryptor: Cryptor,
    ) {}

    async setItem(key: string, value: string) {
        sessionStorage.setItem(key, await this.encrypt(value))
    }

    async getItem(key: string): Promise<string | null> {
        const value = sessionStorage.getItem(key)
        return value ? await this.decrypt(value) : null
    }

    private async encrypt(value: string): Promise<string> {
        return this.cryptor.encrypt(value)
    }

    private async decrypt(value: string): Promise<string | null> {
        try {
            return await this.cryptor.decrypt(value)
        } catch (error) {
            console.debug("Failed to decrypt value:", error)
            return null
        }
    }

    removeItem(key: string): void {
        this.storage.removeItem(key)
    }
}
